module.exports = __webpack_public_path__ + "assets/clubediario-ico-pickdate.c1cd511f.svg";